import * as React from "react";
import {Divider, Grid, Header} from "semantic-ui-react";
import AceEditor from "react-ace";
import {VersionReportFunction} from "./VersionReportFunction";
import {RecentDeployments} from "./RecentDeployments";
import {ProxMoxStatusPage} from "./ProxMoxStatusPage";
import {SchedulerTasksHealth} from "./SchedulerTasksHealth";
import {GrayLogStatus} from "./GrayLogStatus";


export interface HealthAndVersionReportPageProps {

}

export class HealthAndVersionReportPage extends React.Component<HealthAndVersionReportPageProps, any> {

    constructor(props) {
        super(props)
        this.state = {
            displayText: ""
        }
    }


    render() {
        return <Grid padded="horizontally" stackable>
            <Grid.Row columns={2} verticalAlign="top">
                <Grid.Column largeScreen={10} computer={10} tablet={16} mobile={16}>
                    <RecentDeployments/>
                </Grid.Column>
                <Grid.Column largeScreen={6} computer={6} tablet={16} mobile={16}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}>
                        <SchedulerTasksHealth/>
                        <GrayLogStatus previousResponse={null}/>
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2} verticalAlign="top">
                <Grid.Column largeScreen={10} computer={10} tablet={16} mobile={16}>
                    <Header as="h4" style={{marginTop: 0}}>Service Health & Versions</Header>
                    <VersionReportFunction
                        lightView={false}
                        displayDetails={(details: string) => this.setState({displayText: details})}
                    />
                </Grid.Column>
                <Grid.Column largeScreen={6} computer={6} tablet={16} mobile={16}>
                    <AceEditor
                        theme="monokai"
                        mode='groovy'
                        value={this.state.displayText}
                        width="100%"
                        height="800px"
                        readOnly={true}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Divider/>
                    <ProxMoxStatusPage/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    }

}


